import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DialogAlert" }
const _hoisted_2 = { class: "text-text mx-3 my-4 text-center sm:text-left text-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Polygonjs is a node-based WebGL design tool. Learn more at", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "ml-1 text-blue-500 hover:text-blue-600 border-b-2 border-blue-500",
  target: "_blank",
  href: "https://polygonjs.com"
}, "https://polygonjs.com", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Version:", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "polygonjs:", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "editor", -1 /* HOISTED */)
const _hoisted_12 = { class: "text-xs text-text-faded" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-blue-500 hover:text-blue-600 border-b-2 border-blue-500",
  target: "_blank",
  href: "https://polygonjs.com/changelog"
}, "See what's new ->", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "mt-5 mr-3 sm:mt-4 sm:flex sm:flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      displayed: true,
      title: 'About Polygonjs',
      ref: "modal",
      onClose: _ctx.close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", null, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.versionPolygonjs) + " ", 1 /* TEXT */),
            _hoisted_10,
            _hoisted_11,
            _createTextVNode(": " + _toDisplayString(_ctx.versionEditor), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_12, "This scene contains " + _toDisplayString(_ctx.nodesCount) + " nodes.", 1 /* TEXT */),
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            id: "dialog-prompt-cancel",
            type: "button",
            class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-bg-medium hover:bg-bg-dark text-base font-medium text-text hover:text-text-light sm:mt-0 sm:w-auto sm:text-sm cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, " Close ")
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClose"])
  ]))
}